import {IGetNotificationsRequest} from "@source/api/models/notificationModels";
import NotificationService from "@source/api/services/notificationService";

export default class NotificationController {
  static async getNotifications(req: IGetNotificationsRequest) {
    return await NotificationService.getNotifications(req);
  }

  static async getUnreadCount() {
    return await NotificationService.getUnreadCount();
  }
}
